import { useEffect } from "react";
import { Flex, Box, Skeleton } from "@chakra-ui/react";
import environment from "src/utils/environment";
import { isVideoEvent } from "src/modules/activity-log/supported-events";
import { getAppValue } from "src/utils/environment";
import SvgContainer from "src/components/SvgContainer";
import { Caption, BodyText2 } from "src/atoms/typography";
import time from "src/utils/time";
import Fade from "src/components/Fade";
import { ReactComponent as NoisyIcon } from "src/modules/activity-log/icons/noisy.svg";

import { ReactComponent as PlayIcon } from "./play.svg";
import { ReactComponent as PhotoIcon } from "./camera-outlined.svg";
import { ReactComponent as VideoIcon } from "./video-outlined.svg";
import { ReactComponent as MotionBaby } from "./motion-baby.svg";
import { ReactComponent as MotionDog } from "./motion-dog.svg";

export default function CaptureEvent({
  startTimeColumnWidth,
  activityLogType,
  formattedStartTime,
  event,
  openEventView,
  hasParent,
  // isLive,
  fetchEventThumbnail
}) {
  const minimumDimensions = activityLogType === "live" ? 110 : 120;
  // const imageFrameWidth = event.mediaRatio * minimumDimensions;
  const imageFrameMaxWidth =
    activityLogType === "live" ? minimumDimensions : 220;
  const imageFrameMinWidth = minimumDimensions;
  const icons = {
    motion: getAppValue({ bibino: MotionBaby, barkio: MotionDog }),
    awake: NoisyIcon,
    manualPhoto: PhotoIcon,
    manualVideo: VideoIcon
  };

  useEffect(() => {
    async function getThumbnail() {
      if (!event.thumbnailSrc && fetchEventThumbnail) {
        await fetchEventThumbnail(event);
      }
    }
    getThumbnail();
  }, [event, fetchEventThumbnail]);

  function getIcon() {
    const { eventType } = event;
    if (eventType.includes("MOTION")) return icons.motion;
    if (eventType.includes("AWAKE")) return icons.awake;
    if (eventType.includes("PHOTO")) return icons.manualPhoto;
    if (eventType.includes("VIDEO")) return icons.manualVideo;
  }
  let Icon;
  if (!hasParent) {
    Icon = getIcon();
  }

  return (
    <Flex alignItems="center" height="36px">
      {!hasParent && (
        <Caption
          textAlign="right"
          mr="16px"
          color="mediumEmphasis"
          width={startTimeColumnWidth + "px"}
          flex="0 0 auto"
        >
          {formattedStartTime}
        </Caption>
      )}
      {hasParent ? (
        <Box
          height="100%"
          width={startTimeColumnWidth + 27 + "px"}
          borderRight="2px solid"
          borderColor="outline"
        />
      ) : (
        <SvgContainer
          mr="16px"
          fill={
            event.eventType.includes("MANUAL")
              ? "lowEmphasis"
              : event.eventType.includes("MOTION") && environment.isBibino
              ? "primary"
              : "warningBase"
          }
          icon={Icon}
          size="20px"
        />
      )}
      <Flex
        ml={hasParent ? "25px" : "0px"}
        onClick={openEventView}
        bg="iconBackground"
        borderRadius="12px"
        flexGrow={1}
        height={minimumDimensions + "px"}
        border-radius="12px"
        maxW={imageFrameMaxWidth + "px"}
        minW={imageFrameMinWidth + "px"}
        position="relative"
        transition="filter 0.3s"
        _hover={{
          filter: "brightness(1.1)",
          "#play_button": {
            opacity: 1
          }
        }}
      >
        <Fade
          style={{ width: "100%" }}
          in={Boolean(event.thumbnailSrc)}
          duration={{
            enter: 0.3,
            exit: 0
          }}
        >
          {event.thumbnailSrc ? (
            <Flex
              backgroundImage={`url(${event.thumbnailSrc})`}
              backgroundSize="cover"
              backgroundRepeat="no-repeat"
              backgroundPosition="center"
              width="100%"
              height="100%"
              borderRadius="12px"
            />
          ) : (
            <Skeleton width="100%" height="100%" borderRadius="12px" />
          )}
        </Fade>
        {isVideoEvent(event.eventType) && (
          <BodyText2
            px="8px"
            pt="8px"
            textAlign="right"
            color="white"
            position="absolute"
            right="0px"
            top="0px"
            width="100%"
            bottom="70%"
            borderTopLeftRadius="12px"
            borderTopRightRadius="12px"
            backgroundImage="linear-gradient(to top,rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.2))"
          >
            {time(
              event.duration ||
                event.fileRelatedLength ||
                event.fileRelatedDuration
            ).format("mm:ss")}
          </BodyText2>
        )}
        {isVideoEvent(event.eventType) && (
          <Box
            id="play_button"
            bg="black20"
            p="8px"
            position="absolute"
            transform="translate(-50%, -50%)"
            top="50%"
            left="50%"
            borderRadius="100%"
            transition="opacity 0.3s"
            opacity={event.fileExtension === "webp" ? 0 : 1}
          >
            <SvgContainer icon={PlayIcon} size="24px" fill="white" />
          </Box>
        )}
      </Flex>
    </Flex>
  );
}
